import React from 'react'
import { Helmet } from 'react-helmet-async'
import ARDashboardComponent from 'src/pages/app-rationalization/ARDashboard/ARDashboardComponent'

const ARDashboard = () => (
    <>
      <Helmet>
        <title> Dashboard: AR Dashboard</title>
      </Helmet>

      <ARDashboardComponent />
    </>
  )

export default ARDashboard